import LinearProgress from '@mui/material/LinearProgress';
import classNames from 'classnames';
import { ReactElement } from 'react';

import { BarTone } from '~/ui/pages/Clients/reusable/CommunityEngagement/helpers/getBarTone';
import getProgressPercent from '~/ui/pages/Clients/reusable/CommunityEngagement/helpers/getProgressPercent';

import styles from './ProgressRow.module.scss';

interface IProgressRowProps {
  label: string;
  total: number;
  threshold: number | null;
  tone: BarTone;
  format: (value: number) => string;
}

const ProgressRow = ({
  label,
  total,
  threshold,
  tone,
  format,
}: IProgressRowProps): ReactElement => {
  const rest = threshold === null ? '' : ` / ${format(threshold)}`;

  return (
    <div className={styles.progressRow}>
      <span className={styles.progressLabel}>
        <span
          className={classNames(
            styles.progressTotal,
            tone === BarTone.NoThreshold && styles.noThresholdLabel,
            tone === BarTone.TargetInProgress && total > 0 && styles.targetInProgressLabel,
          )}
        >
          {format(total)}
        </span>
        {rest}
      </span>
      <LinearProgress
        aria-label={label}
        data-tone={tone}
        variant="determinate"
        value={getProgressPercent(total, threshold)}
        classes={{ root: styles.progressTrack, bar: styles[`${tone}Bar`] }}
      />
    </div>
  );
};

export default ProgressRow;
